export const PROMO_URL =
  'https://firework.com/video-solutions-for-entrepreneurs/?utm_source=website&utm_content=widget&utm_campaign=poweredbyfirework'

export enum PlaySourceEnum {
  AUTOPLAY = 'autoplay',
  PLAYER = 'player',
}

/**
 * Represents the ready state of the video element:
 * 0 = HAVE_NOTHING - no information whether or not the video is ready
 * 1 = HAVE_METADATA - metadata for the video is ready
 * 2 = HAVE_CURRENT_DATA - data for the current playback position is available, but not enough data to play next frame/millisecond
 * 3 = HAVE_FUTURE_DATA - data for the current and at least the next frame is available
 * 4 = HAVE_ENOUGH_DATA - enough data available to start playing
 */
export enum VideoWrapperReadyStatus {
  HAVE_NOTHING = 0,
  HAVE_METADATA = 1,
  HAVE_CURRENT_DATA = 2,
  HAVE_FUTURE_DATA = 3,
  HAVE_ENOUGH_DATA = 4,
}

export enum agoraConnectionState {
  DISCONNECTED = 'DISCONNECTED',
  CONNECTING = 'CONNECTING',
  RECONNECTING = 'RECONNECTING',
  CONNECTED = 'CONNECTED',
  DISCONNECTING = 'DISCONNECTING',
}

export const DETACHED_PLAYER_ID = 'fw-player'
